gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother);

let smoother = ScrollSmoother.get();
const SCROLL_DURATION = 1;
const SCROLL_EASE = "power3.inOut";

ScrollTrigger.create({
  trigger: "#MainContent",
  pin: ".co-case-menu",
  pinType: smoother ? "transform" : "fixed",
  start: "top top",
  end: () => {
    const main = document.querySelector("#MainContent");
    const menu = document.querySelector(".co-case-menu");
    if (!main || !menu) return "+=0";
    return "+=" + (main.offsetHeight - menu.offsetHeight);
  }
});

document.querySelectorAll('.co-case-menu a').forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    const target = e.currentTarget.getAttribute('data-target');
    if (!target) return;

    history.pushState(null, '', '#' + target);

    const selector = "#" + target;

    if (smoother) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(selector, "top top"),
        duration: SCROLL_DURATION,
        ease: SCROLL_EASE,
        overwrite: true
      });
    } else {
      gsap.to(window, {
        duration: SCROLL_DURATION,
        ease: SCROLL_EASE,
        scrollTo: selector
      });
    }
  });
});

document.querySelectorAll('.co-section').forEach(section => {
  ScrollTrigger.create({
    trigger: section,
    start: "top center",
    end: "bottom center",
    onEnter: () => setActive(section.id),
    onEnterBack: () => setActive(section.id)
  });
});

function setActive(id) {
  document.querySelectorAll('.co-case-menu a')
    .forEach(a => a.classList.remove('active'));

  const activeLink = document.querySelector(`.co-case-menu a[data-target="${id}"]`);
  if (activeLink) activeLink.classList.add('active');

  if (window.location.hash !== '#' + id) {
    history.replaceState(null, '', '#' + id);
  }
}

function scrollToHash() {
  const hash = window.location.hash;
  if (!hash) return;

  const target = hash.substring(1);
  const el = document.getElementById(target);
  if (!el) return;

  requestAnimationFrame(() => {
    if (smoother) {
      gsap.to(smoother, {
        scrollTop: smoother.offset('#' + target, "top top"),
        duration: SCROLL_DURATION,
        ease: SCROLL_EASE,
        overwrite: true
      });
    } else {
      gsap.to(window, {
        duration: SCROLL_DURATION,
        ease: SCROLL_EASE,
        scrollTo: '#' + target
      });
    }

    setActive(target);
  });
}

scrollToHash();
window.addEventListener('popstate', scrollToHash);

ScrollTrigger.refresh();

// ================================================ SCROLL TRIGGER ANIMATIONS
let co_duration = 1;
let co_ease = "Power1.out";
let co_y = 20;

gsap.set(".co-case-menu-frame-1", { opacity: 0, xPercent: -100 });
gsap.to(".co-case-menu-frame-1", {
  xPercent: 0,
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});

gsap.set(".co-case-1-frame", { opacity: 0, y: co_y });
gsap.to(".co-case-1-frame", {
  y: 0,
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});

gsap.set(".co-case-2-frame", { opacity: 0, y: co_y });
gsap.to(".co-case-2-frame", {
  scrollTrigger: {
    trigger: ".co-case-2-frame",
    start: "top 90%",
    end: "bottom bottom"
  },
  y: 0,
  opacity: 1,
  duration: co_duration,
  ease: co_ease
});

gsap.set(".co-case-3-frame", { opacity: 0, y: co_y });
gsap.to(".co-case-3-frame", {
  scrollTrigger: {
    trigger: ".co-case-3-frame",
    start: "top 90%",
    end: "bottom bottom"
  },
  y: 0,
  opacity: 1,
  duration: co_duration,
  ease: co_ease
});

gsap.set(".co-case-4-frame", { opacity: 0, y: co_y });
gsap.to(".co-case-4-frame", {
  scrollTrigger: {
    trigger: ".co-case-4-frame",
    start: "top 90%",
    end: "bottom bottom"
  },
  y: 0,
  opacity: 1,
  duration: co_duration,
  ease: co_ease
});

gsap.set(".co-case-5-frame", { opacity: 0, y: co_y });
gsap.to(".co-case-5-frame", {
  scrollTrigger: {
    trigger: ".co-case-5-frame",
    start: "top 90%",
    end: "bottom bottom"
  },
  y: 0,
  opacity: 1,
  duration: co_duration,
  ease: co_ease
});